import axios from 'axios';
import { Comment, CommentType, CreateCommentData, CreateCommentResult } from '../types/comment';

import { API_URL } from '../config/api';

export const commentService = {
    getByBusinessId: async (businessId: string, userEmail?: string): Promise<Comment[]> => {
        const response = await axios.get(`${API_URL}/businesses/${businessId}/comments`, {
            params: { userEmail }
        });
        return response.data;
    },

    create: async (data: CreateCommentData): Promise<CreateCommentResult> => {
        const response = await axios.post(`${API_URL}/comments`, data);
        return response.data;
    },

    like: async (id: string, userEmail: string): Promise<{ liked: boolean }> => {
        const response = await axios.post(`${API_URL}/comments/${id}/like`, { userEmail });
        return response.data;
    },

    reply: async (id: string, userEmail: string, reply: string): Promise<Comment> => {
        const response = await axios.post(`${API_URL}/comments/${id}/reply`, { userEmail, reply });
        return response.data;
    },

    // Admin methods
    getAllAdmin: async (userEmail: string, status?: string, type?: CommentType | ''): Promise<(Comment & { business?: { name: string; slug?: string } })[]> => {
        const response = await axios.get(`${API_URL}/admin/comments`, {
            params: { userEmail, status, type: type || undefined }
        });
        return response.data;
    },

    updateType: async (id: string, userEmail: string, type: CommentType): Promise<Comment> => {
        const response = await axios.put(`${API_URL}/admin/comments/${id}/type`, { userEmail, type });
        return response.data;
    },

    updateStatus: async (id: string, userEmail: string, status: 'approved' | 'rejected' | 'pending'): Promise<Comment> => {
        const response = await axios.put(`${API_URL}/admin/comments/${id}/status`, {
            userEmail,
            status
        });
        return response.data;
    },

    delete: async (id: string, userEmail: string): Promise<void> => {
        await axios.delete(`${API_URL}/admin/comments/${id}`, {
            params: { userEmail }
        });
    },

    getCommentStats: async (userEmail: string): Promise<{ approved: number, pending: number, total: number, rejected: number, questions?: number, autoApproved?: number, autoRejected?: number }> => {
        const response = await axios.get(`${API_URL}/admin/comment-stats`, {
            params: { userEmail }
        });
        return response.data;
    }
};
